import { Component, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-smart-table-hyperlink',
  templateUrl: './smart-table-hyperlink.component.html',
  styleUrls: ['./smart-table-hyperlink.component.scss'],
})
export class SmartTableHyperlinkComponent implements ViewCell, OnInit {
  constructor() {}
  value: any;
  rowData: any;
  showHyperlink: boolean = false;
  showPlainText: boolean = false;

  ngOnInit(): void {
    try {
      this.value = JSON.parse(this.value as any);
      this.showPlainText = this.value?.showPlainText;
      this.value = this.value.data;
      if (!this.showPlainText) {
        this.isValidURL(this.value);
      }
    } catch (error) {}
  }

  isValidURL(s: any) {
    var regexp =
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    this.showHyperlink = regexp.test(s);
  }
}
